// extracted by mini-css-extract-plugin
module.exports = {"clientStatusLabel":"clientStatusLabel--Xwwd5"};